// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://asanupdeaeolcnrrovhn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFzYW51cGRlYWVvbGNucnJvdmhuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkyNzU1MTEsImV4cCI6MjA4NDg1MTUxMX0.2b4Q4YLXQO49r2yEId5__uTmivKw5y2dHACubHcuoQg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});